var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{fill:url(#SVGID_12_);}\n\t.st12{fill:url(#SVGID_13_);}\n\t.st13{fill:url(#SVGID_14_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 302.999,
    y1: 600,
    x2: 897.0012,
    y2: 600
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M709.9,979.8c-127.1,0-254.2,0-381.3,0c-18.8-7.9-25.7-21.9-25.6-42.5c0.5-224.9,0.4-449.7,0-674.6 c0-20.4,6.6-34.6,25.6-42.5c181.1,0,362.3,0,543.4,0c18.7,8.3,25.1,22.4,25,42.9c-0.5,173.4-0.1,346.7-0.6,520.1 c0,6.9-4.3,15.3-9.3,20.4c-53,54.4-106.5,108.3-160,162.2C722,971.1,715.7,975.2,709.9,979.8z M866.1,251 c-4.6-0.3-7.5-0.6-10.4-0.6c-170.1,0-340.2,0.2-510.3-0.4c-14.4,0-13.4,7.4-13.4,16.8c0.1,222.1,0.2,444.3-0.2,666.4 c0,13.1,3.2,16.9,16.6,16.8c109.6-0.6,219.1-0.3,328.7-0.3c4.7,0,9.4,0,14.7,0c0-45.1-0.2-87.6,0.1-130.1c0.2-28.3,19-47,47-47.2 c37-0.2,74-0.1,111.1-0.1c5.3,0,10.6,0,16.2,0C866.1,597.7,866.1,425.2,866.1,251z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.625,
    y1: 570.2501,
    x2: 814.1013,
    y2: 570.2501
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M600.2,709.4c-64.5,0-129,0-193.4,0c-17.9,0-20.1-2-20.1-19.5c-0.1-79.5-0.1-159,0-238.4 c0-17.9,2.3-20.3,19.4-20.3c129.5-0.1,258.9,0.1,388.4-0.2c14.2,0,19.7,4.8,19.6,19.2c-0.4,80-0.1,160-0.2,239.9 c0,17.4-2.3,19.4-20.2,19.4C729.2,709.4,664.7,709.4,600.2,709.4z M790.9,687.5c0.7-2.1,1.7-3.4,1.7-4.8c0.1-44.5,0-89,0.4-133.5 c0.1-11.4-7.3-9.7-14.1-9.7c-119,0-237.9,0.1-356.9-0.2c-11.1,0-14.6,3-14.4,14.3c0.6,40.5,0.2,81,0.3,121.5 c0,4.2,0.8,8.5,1.2,12.5C537.4,687.5,664.2,687.5,790.9,687.5z M792,453.2c-128.7,0-255.8,0-383.3,0c0,21.9,0,42.7,0,64 c128.1,0,255.3,0,383.3,0C792,495.7,792,474.9,792,453.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.8998,
    y1: 834.55,
    x2: 562.7046,
    y2: 834.55
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M473.4,924c-50,0.4-90.4-39.8-90.5-90.1c-0.1-48.4,39.9-88.4,88.5-88.8c50.5-0.4,90.9,39,91.3,89.2 C563.2,883.1,522.8,923.6,473.4,924z M544.9,834.7c-0.1-40.4-32.3-72.8-72.2-72.6s-72.2,33-71.9,72.9c0.3,39.1,32.6,71.7,71.6,72.1 C511.8,907.5,544.9,874.5,544.9,834.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.6,
    y1: 647.5179,
    x2: 757.5,
    y2: 647.5179
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M598.8,637c45.5,0,91,0,136.5,0c3.5,0,7.6-1.1,10.4,0.3c4.4,2.2,7.9,6.1,11.8,9.3c-3.8,3.8-7.3,8.1-11.7,11.1 c-2.1,1.4-5.8,0.4-8.8,0.4c-93,0-186,0-278.9,0c-2.5,0-5.7,0.9-7.4-0.2c-4.7-3.2-8.8-7.4-13.1-11.2c4.3-3.2,8.3-8.7,13-9.2 c11.3-1.4,22.9-0.5,34.4-0.5C522.9,637,560.9,637,598.8,637z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 438.0477,
    y1: 581.45,
    x2: 674.5,
    y2: 581.45
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M556.4,570.9c33.9,0,67.9,0,101.8,0c7.5,0,16.3-1.1,16.3,10.1c0,10.4-7.9,11.1-15.9,11.1 c-68.4,0-136.7,0-205.1,0c-8.2,0-16.7-1.5-15.3-11.2c0.6-4,9.6-9.5,14.9-9.6C487.5,570.5,521.9,570.9,556.4,570.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.887,
    y1: 485.85,
    x2: 674.7,
    y2: 485.85
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M555.2,496.4c-33.4,0-66.9-0.1-100.3,0.1c-8.5,0-17.4-0.2-17-11.3c0.4-10,9-10,16.9-10 c67.9,0.1,135.8,0,203.7,0.1c7.7,0,16.2-0.5,16.2,10.4c0,10.6-8.1,10.8-16,10.8C624.1,496.4,589.6,496.4,555.2,496.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 424.2912,
    y1: 834.5,
    x2: 521.5126,
    y2: 834.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M521.5,836c-0.6,26.8-22.8,48.2-49.4,47.7c-27.4-0.5-48.3-22.8-47.8-50.8c0.5-26.7,22.7-48.1,49.4-47.6 C501.2,785.8,522.1,808,521.5,836z M473.5,865.7c17.3-0.2,31.4-14.6,31-31.7c-0.3-17.1-15.1-31.4-32.2-31.1 c-17.3,0.3-31.1,14.8-30.7,32.2C442,852.9,455.6,865.9,473.5,865.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.1,
    y1: 344.25,
    x2: 454.4,
    y2: 344.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M454.4,316.7v55.1h-17.3v-55.1H454.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 462.2,
    y1: 344.25,
    x2: 515.1,
    y2: 344.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M515.1,371.8h-17.3l-18.3-27.7v27.7h-17.3v-55.1h17.3l18.3,28.2v-28.2h17.3V371.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 519,
    y1: 344.25,
    x2: 578.4,
    y2: 344.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M578.4,316.7l-18.5,55.1h-22.3L519,316.7h18.4l11.4,37.9l11.3-37.9H578.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 580.8,
    y1: 344.05,
    x2: 637.5,
    y2: 344.05
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M594.9,368.7c-4.3-2.4-7.8-5.8-10.3-10.1c-2.5-4.3-3.8-9.2-3.8-14.6s1.3-10.3,3.8-14.6 c2.5-4.3,6-7.7,10.3-10.1s9.1-3.6,14.3-3.6s9.9,1.2,14.3,3.6c4.3,2.4,7.7,5.8,10.2,10.1c2.5,4.3,3.8,9.2,3.8,14.6 s-1.3,10.3-3.8,14.6c-2.5,4.3-5.9,7.7-10.3,10.1c-4.3,2.4-9.1,3.7-14.2,3.7C604,372.3,599.2,371.1,594.9,368.7z M617.1,352.9 c1.9-2.2,2.8-5.2,2.8-8.9c0-3.8-0.9-6.8-2.8-9c-1.9-2.2-4.5-3.3-7.9-3.3c-3.5,0-6.2,1.1-8,3.3c-1.9,2.2-2.8,5.2-2.8,9 c0,3.7,0.9,6.7,2.8,8.9c1.9,2.2,4.5,3.3,8,3.3C612.6,356.2,615.2,355.1,617.1,352.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 643.6,
    y1: 344.25,
    x2: 660.9,
    y2: 344.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M660.9,316.7v55.1h-17.3v-55.1H660.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 667.2,
    y1: 344.3,
    x2: 721.2,
    y2: 344.3
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M670.5,329.6c2.2-4.3,5.4-7.6,9.5-9.9c4.1-2.4,8.9-3.5,14.5-3.5c4.8,0,9,0.9,12.8,2.7 c3.8,1.8,6.8,4.3,9.2,7.6s3.9,7.1,4.7,11.4H703c-0.8-1.8-2-3.2-3.5-4.2s-3.3-1.5-5.3-1.5c-2.9,0-5.2,1.1-6.9,3.3 c-1.7,2.2-2.5,5.1-2.5,8.8c0,3.7,0.8,6.6,2.5,8.8c1.7,2.2,4,3.3,6.9,3.3c2,0,3.7-0.5,5.3-1.5c1.5-1,2.7-2.4,3.5-4.2h18.2 c-0.8,4.4-2.3,8.2-4.7,11.4s-5.4,5.8-9.2,7.6c-3.8,1.8-8,2.7-12.8,2.7c-5.6,0-10.4-1.2-14.5-3.5c-4.1-2.4-7.3-5.7-9.5-9.9 c-2.2-4.3-3.3-9.1-3.3-14.6S668.3,333.8,670.5,329.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 727.3,
    y1: 344.2499,
    x2: 764.1,
    y2: 344.2499
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M744.6,330.4v6.8h17.1v13h-17.1v7.8h19.5v13.8h-36.8v-55.1h36.8v13.8L744.6,330.4L744.6,330.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice03);
export default __webpack_public_path__ + "static/media/Invoice-03.36e1fb581bcdf244e6290e1a41981c61.svg";
export { ForwardRef as ReactComponent };